import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  // 首页
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    component: () => import('../views/index/index'),
    meta: {
      title: '中国木偶艺术剧院'
    }
  },
  {
    path: '/admin',
    component: () => import('../views/admin/index'),
    meta: {
      requireAuth: true,
      title: '个人中心-中国木偶艺术剧院'
    }
  },
  {
    path: '/cat',
    component: () => import('../views/cat/index'),
    meta: {
      requireAuth: true,
      title: '购物车-中国木偶艺术剧院'
    }
  },
  {
    path: '/pay',
    component: () => import('../views/cat/pay'),
    meta: {
      title: '木偶剧院-中国木偶艺术剧院'
    }
  },
  {
    path: '/center',
    component: () => import('../views/center/index'),
    meta: {
      title: '演出中心-中国木偶艺术剧院'
    }
  },
  {
    path: '/center/detail',
    component: () => import('../views/center/components/detail'),
    meta: {
      title: '演出详情-中国木偶艺术剧院'
    }
  },
  {
    path: '/cloudTheater',
    component: () => import('../views/cloudTheater/index'),
    meta: {
      title: '木偶云剧院-中国木偶艺术剧院'
    }
  },
  {
    path: '/cloudTheater/detail',
    component: () => import('../views/cloudTheater/components/detail'),
    meta: {
      title: '剧目详情-中国木偶艺术剧院'
    }
  },
  {
    path: '/cooperation',
    component: () => import('../views/cooperation/index'),
    meta: {
      title: '商业合作-中国木偶艺术剧院'
    }
  },
  {
    path: '/brand',
    component: () => import('../views/cooperation/brand'),
    meta: {
      title: '品牌加盟-中国木偶艺术剧院'
    }
  },
  {
    path: '/education',
    component: () => import('../views/education/index'),
    meta: {
      title: '艺术教育-中国木偶艺术剧院'
    }
  },
  {
    path: '/onlineedu',
    component: () => import('../views/education/onlineedu'),
    meta: {
      title: '在线教育-中国木偶艺术剧院'
    }
  },
  {
    path: '/goods',
    component: () => import('../views/goods/index'),
    meta: {
      title: '文创产品-中国木偶艺术剧院'
    }
  },
  {
    path: '/goods/detail',
    component: () => import('../views/goods/detail'),
    meta: {
      title: '文创产品-中国木偶艺术剧院'
    }
  },
  {
    path: '/news',
    component: () => import('../views/news/index'),
    meta: {
      title: '新闻动态-中国木偶艺术剧院'
    }
  },
  {
    path: '/news/detail',
    component: () => import('../views/news/components/detail'),
    meta: {
      keepAlive: true,
      title: '新闻动态-中国木偶艺术剧院'
    }
  },
  {
    path: '/overview',
    component: () => import('../views/overview/index'),
    meta: {
      title: '剧院概览-中国木偶艺术剧院'
    }
  },
  {
    path: '/agreement',
    component: () => import('../views/login/components/agreement'),
    meta: {
      title: '中国木偶艺术剧院'
    }
  },

  // 放在最后
  {
    path: '/404',
    name: '404',
    component: () => import('../views/error/404'),
    meta: {
      title: '404'
    }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

// add route path
routes.forEach((route) => {
  route.path = route.path || '/' + (route.name || '')
})

const router = new Router({
  // mode: 'history',
  routes
})

export {
  router
}


// WEBPACK FOOTER //
// ./src/router/index.js